import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ToDoListState, todoFeatureKey } from '../reducers/todo.reducer';
import * as fromToDoReducer from '../reducers';
import * as fromToDoListReducer from '../reducers/todo.reducer';

//#region TO DO STATE
export const getBusinessesState = createFeatureSelector<fromToDoReducer.State, ToDoListState>(fromToDoReducer.todoFeatureKey);
//#endregion

//#region ToDo list STATE
export const getToDoListState = createSelector(getBusinessesState, state => state[todoFeatureKey]);

export const getToDoListRequest = createSelector(getToDoListState, fromToDoListReducer.getToDoRequest);

export const getToDoListResponse = createSelector(getToDoListState, fromToDoListReducer.getToDoResponse);

export const getToDoListFailure = createSelector(getToDoListState, fromToDoListReducer.getToDoFailure);

export const getToDoIsLoaded = createSelector(getToDoListState, fromToDoListReducer.getToDoIsLoaded);

export const selectLegalEntityTabIndex = createSelector(getToDoListState, fromToDoListReducer.getLegalEntityTabControlsIndex);
